export default {
  toasts: {
    verification_pending: 'Your verification is still pending',
  },
};
